<template>
  <div class="sign-in-wrapper">
    <span v-if="errorMsg" class="alert -danger">{{ errorMsg }}</span>

    <div class="sign-in">
      <h3 class="site-logo">Ripley Chat</h3>
      <form novalidate @submit.prevent="signIn">
        <input v-model="email" type="email" placeholder="Your email address" />
        <input v-model="password" type="password" placeholder="Your password" />

        <action-button :text="'Sign in'" :state="state" @pressed="signIn"></action-button>
      </form>
    </div>
  </div>
</template>

<script>
import actionButton from "@/components/actionButton";
import api from "@/helpers/api";
import auth from "@/helpers/auth";

export default {
  components: { actionButton },
  beforeRouteEnter(to, from, next) {
    if (auth.signedIn()) return next("/dashboard");
    next();
  },

  data() {
    return {
      email: "",
      password: "",
      state: "normal",
      errorMsg: ""
    };
  },

  methods: {
    signIn() {
      if (this.state !== "normal") return;
      this.state = "loading";
      this.errorMsg = "";

      api
        .instance()
        .post("oauth/token", {
          email: this.email,
          password: this.password,
          client_id: process.env.API_CLIENT_ID,
          client_secret: process.env.API_CLIENT_SECRET
        })
        .then((resp) => {
          this.state = "done";
          setTimeout(() => {
            this.$store.dispatch("signIn", resp.data.access_token);
            this.$router.push("/");
          }, 1000);
        })
        .catch((err) => {
          this.password = "";
          this.state = "normal";
          this.errorMsg = "Sign in failed, please try again";

          console.error("Sign in error:", err);
        });
    }
  }
};
</script>
